import { useEffect, useMemo, useState, useTransition } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { Lodging } from "@b2bportal/lodging-api";
import { usePerformFilterOnHotelList } from "@tenant/hotels";
import { HotelsAvailabilitySelectors } from "../store";

export const useHotelList = () => {
  const [isHotelListFiltering, startTransition] = useTransition();

  const dispatch = useDispatch();
  const hotels = useSelector(HotelsAvailabilitySelectors.getHotels);
  const { handlers } = usePerformFilterOnHotelList();
  const [hotelList, setHotelList] = useState<Lodging[]>(hotels);

  useEffect(() => {
    startTransition(() => {
      if (hotels.length > 0) {
        const result = hotels.filter((hotel) => handlers.performFilter(hotel));
        setHotelList((prev) => {
          if (prev.length !== result.length) return result;

          // Optimize so that we do not re-render components.
          // Keep the same memory pointer as filter creates a new memory pointer.
          if (prev.every((val, i) => val.lodging.id === result[i].lodging.id)) {
            return prev;
          }
          return result;
        });
      }
    });
  }, [hotels, dispatch, handlers]);

  return useMemo(
    () => ({
      context: {
        isHotelListFiltering,
        hotelsList: hotelList ?? [],
      },
    }),
    [hotelList, isHotelListFiltering]
  );
};
